import 'jquery-mask-plugin'
import * as _ from 'lodash'

/**
 * Classe abstrata para simplificar a criação de máscaras dinâmicas.
 *
 * Extenda e implemente o método "maskBehavior"
 */
class Mask {
  constructor(el, binding, vnode) {
    this.el = el;

    $(el).mask(this.maskBehavior, this.getOptions());

    // Chama o evento input no elemento se houver binding
    $(el).on('change.mask keyup', function (e) {
        // @change so deve propagar no evento 'change' real (blur), nunca no 'keyup',
        // para nao disparar handlers de change duas vezes (keyup + change).
        if(e.type === 'change' && vnode.data.on && vnode.data.on.change){
          vnode.data.on.change(e)
        }
        if(vnode.data.on && vnode.data.on.input){
          vnode.data.on.input(e)
        }
        if(vnode.data.nativeOn && vnode.data.nativeOn.input){
          vnode.data.nativeOn.input(e)
        }
    })
  }

  getOptions() {
    return {
      onKeyPress: this.maskEventHandler.bind(this),
      onBlur: this.maskEventHandler.bind(this),
    }
  }

  maskBehavior(val, e, field, options) {
    throw "NotImplemented";
  }

  maskEventHandler(val, e, field, options) {
    field.mask(this.maskBehavior(val, e, field, options), options);
  };
}

/**
 * Normaliza letras para maiúsculas (CNPJ alfanumérico).
 */
class MaskUppercaseAlphanumeric extends Mask {
  maskEventHandler(val, e, field, options) {
    const normalized = (val || '').toUpperCase();
    if (normalized !== val) {
      field.val(normalized).trigger('input');
    }
    field.mask(this.maskBehavior(normalized, e, field, options), options);
  }
}

/**
 * Máscara para CPF/CNPJ
 */
class MaskCpfCnpj extends MaskUppercaseAlphanumeric {
  maskBehavior(val, e, field, options) {
    const cleaned = val.replace(/[.\-\/]/g, '');
    // Slots extras (AAAAA) ao final permitem ultrapassar 11 caracteres e disparar a troca para CNPJ.
    return cleaned.length <= 11 ? 'AAA.AAA.AAA-AAAAA' : 'AA.AAA.AAA/AAAA-00';
  }
}

/**
 * Másca para "dinheiro" com comportamento select-on-focus.
 */
class MaskMoney extends Mask {
  maskBehavior(val, e, field, options) {
    return '000.000.000.000.000,00'
  }

  getOptions() {
    _.extend({}, super.getOptions(), {
      reverse: true, selectOnFocus: true
    })
  }
}

class MaskOneReal extends Mask {
  maskBehavior(val, e, field, options) {
    return '0,00'
  }

  getOptions() {
    _.extend({}, super.getOptions(), {
      reverse: true, selectOnFocus: true
    })
  }
}

class MaskTel extends Mask {
  maskBehavior(val, e, field, options) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  }
}

class MaskCard extends Mask {
  maskBehavior(val, e, field, options) {
    return '0000.0000.0000.0099';
  }
}

class MaskPlate extends Mask {
  maskBehavior(val, e, field, options) {
    return 'AAA-AAAA';
  }
}

class MaskBirth extends Mask {
  maskBehavior(val, e, field, options) {
    return '00/00/0000';
  }
}

class MaskCpf extends Mask {
  maskBehavior(val, e, field, options) {
    return '000.000.000-00';
  }
}

class MaskCnpj extends MaskUppercaseAlphanumeric {
  maskBehavior(val, e, field, options) {
    return 'AA.AAA.AAA/AAAA-00';
  }
}

class MaskHour extends Mask {
  maskBehavior(val, e, field, options) {
    return '00:00:00';
  }
}

class MaskCep extends Mask {
  maskBehavior(val, e, field, options) {
    return '00000-000';
  }
}

// Diretivas
export const maskCpfCnpj = {
  bind: (el, binding, vnode) => new MaskCpfCnpj(el, binding, vnode)
};

export const maskCpf = {
  bind: (el, binding, vnode) => new MaskCpf(el, binding, vnode)
};

export const maskMoney = {
  bind: (el, binding, vnode) => new MaskMoney(el, binding, vnode)
};

export const maskOneReal = {
  bind: (el, binding, vnode) => new MaskOneReal(el, binding, vnode)
};

export const maskTel = {
  bind: (el, binding, vnode) => new MaskTel(el, binding, vnode)
};

export const maskCard = {
  bind: (el, binding, vnode) => new MaskCard(el, binding, vnode)
};


export const maskPlate = {
  bind: (el, binding, vnode) => new MaskPlate(el, binding, vnode)
};

export const maskBirth = {
  bind: (el, binding, vnode) => new MaskBirth(el, binding, vnode)
};

export const maskCnpj = {
  bind: (el, binding, vnode) => new MaskCnpj(el, binding, vnode)
};

export const maskHour = {
  bind: (el, binding, vnode) => new MaskHour(el, binding, vnode)
};

export const maskCep = {
  bind: (el, binding, vnode) => new MaskCep(el, binding, vnode)
};



// WEBPACK FOOTER //
// ./src/directives/mask.js